import { Div } from 'alkali'
import './LoadingEllipsis.scss'

const LoadingEllipsis = Div.with('.lds-ellipsis', [
  Div('.isnodehere'), Div(), Div(), Div(), Div()
])

export default LoadingEllipsis